import { useQuery } from "../AppLayout";
import { ContentTypes } from "../constants/action-types";
import ListViewEmail from "./list-view/ListViewEmail";
import ListViewNote from "./list-view/ListViewNote";
import ListViewTask from "./list-view/ListViewTask";
import ListViewSkeleton from "./list-view/ListViewSkeleton";

const taskColumns = [
  { label: "Task", flex: "flex-1" },
  { label: "Due date", flex: "flex-1" },
  { label: "Item", flex: "flex-2" },
  { label: "Assigned to", flex: "flex-2" },
];

const noteColumns = [
  { label: "Note", flex: "flex-2" },
  { label: "Created by", flex: "flex-1" },
  { label: "Item", flex: "flex-2" },
  { label: "Created at", flex: "flex-1" },
];

const emailColumns = [
  { label: "Email", flex: "flex-2" },
  { label: "Sent to", flex: "flex-2" },
  { label: "Item", flex: "flex-2" },
  { label: "Created at", flex: "flex-1" },
];

const ListView = ({ items, loading, onSearchTasks }) => {
  const contentType = useQuery().get("type") || "SALE";
  const appView = useQuery().get("key") || "";

  if (loading) {
    if (contentType === ContentTypes.ACTIVITY && appView === "Tasks") {
      return (
        <div className="p-4">
          <ListViewSkeleton columns={taskColumns} showCheckbox rows={6} />
        </div>
      );
    }
    if (contentType === ContentTypes.ACTIVITY && appView === "Notes") {
      return (
        <div className="p-4">
          <ListViewSkeleton columns={noteColumns} rows={6} />
        </div>
      );
    }
    if (
      contentType === ContentTypes.ACTIVITY &&
      (appView === "Drafts" || appView === "Outbox" || appView === "Tracked")
    ) {
      return (
        <div className="p-4">
          <ListViewSkeleton columns={emailColumns} rows={6} />
        </div>
      );
    }
    return null;
  }

  const renderListView = () => {
    if (contentType === ContentTypes.ACTIVITY && appView === "Tasks") {
      return <ListViewTask items={items} onSearchTasks={onSearchTasks} />;
    } else if (contentType === ContentTypes.ACTIVITY && appView === "Notes") {
      return <ListViewNote items={items} onSearchTasks={onSearchTasks} />;
    } else if (
      contentType === ContentTypes.ACTIVITY &&
      (appView === "Drafts" || appView === "Outbox" || appView === "Tracked")
    ) {
      return <ListViewEmail appView={appView} items={items} onSearchTasks={onSearchTasks} />;
    }
    return null;
  };

  return <div className="p-4">{renderListView()}</div>;
};

export default ListView;
